import { render, staticRenderFns } from "./cashback-purchase-v2.vue?vue&type=template&id=763b90d6&scoped=true&lang=pug&"
import script from "./cashback-purchase-v2.vue?vue&type=script&lang=js&"
export * from "./cashback-purchase-v2.vue?vue&type=script&lang=js&"
import style0 from "./cashback-purchase-v2.vue?vue&type=style&index=0&id=763b90d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763b90d6",
  null
  
)

export default component.exports